
/**
 * Created by Ella Ma on 7/13/2020.
 * Description:
 *
 */

import { Injectable } from '@angular/core';
import { catchError, take, map, filter, switchMap } from 'rxjs/operators';
import { of, forkJoin } from 'rxjs';
import { ToastService } from '../../widgets/toast/toast.service';
import { NotificationStyles } from '../../widgets/notification/notification.model';
import { EmailDigestService } from '../../services/email-digest.service';
import { ScreenService } from '../../tamalelibs/services/screen.service';
import { ScreenFocusType } from '../../models/saved-screen';
import { select, Store } from '@ngrx/store';
import { businessConstants } from '../../constants/business.constants';
import { screensSelector } from '../../redux/reducers/system.reducer';
import { AppState } from '../../redux';
import { Router } from '@angular/router';

@Injectable({
    providedIn: 'root'
})

export class EmailDigestServiceCommon {
    constructor(
        private _emailDigestService: EmailDigestService,
        private _screenService: ScreenService,
        private _toast: ToastService,
        private _store: Store<AppState>,
        private _router: Router,
    ) {
    }

    saveEmailDigest(tempDigest) {
        return this._emailDigestService.saveEmailDigest(tempDigest).pipe(
            catchError((e: any) => {
                this._toast.notify({
                    style: NotificationStyles.Error,
                    message: 'Save failed, error: ' + e.message,
                });
                return of(null);
            }),
            take(1),
        );
    }

    updateEmailDigest(tempDigest) {
        return this._emailDigestService.updateEmailDigest(tempDigest).pipe(
            catchError((e: any) => {
                this._toast.notify({
                    style: NotificationStyles.Error,
                    message: 'Save failed, error: ' + e.message,
                });
                return of(null);
            }),
            take(1),
        );
    }

    getDashboardFocusSorce(dashboardId) {
        return this._store.pipe(
            select(screensSelector),
            filter(item => !!item),
            map((screen) => {
                const dashboard = screen.filter(item => item.type === businessConstants.screenType.dashboard && item.id === dashboardId);
                return dashboard;
            }),
            switchMap((screen) => {
                // First get from store, if not has, get from server
                const observables = [];
                if (screen.length === 0) {
                    observables.push(
                        this._screenService.getById(dashboardId).pipe(take(1))
                    );
                }
                if (observables.length === 0) {
                    return of(screen);
                } else {
                    return forkJoin(observables);
                }
            }),
            map(screen => {
                const dashboard = screen[0];
                const showFocus = dashboard.configuration.focus.type === ScreenFocusType.ENABLE_FOCUS_CONTROL;
                let focusSource;
                if (dashboard.configuration.focus.entityTypes && dashboard.configuration.focus.entityTypes.length > 0) {
                    focusSource = {};
                    focusSource['entityType'] = dashboard.configuration.focus.entityTypes;
                }
                const name = dashboard.name;
                return { showFocus, focusSource, name };
            }),
            catchError((e: any) => {
                return of({
                    showFocus: false,
                    focusSource: null,
                    name: ''
                });
            }),
            take(1)
        );
    }
}
